export const SET_IS_AUTH_MENU_OPEN = 'SET_IS_AUTH_MENU_OPEN'
export const SET_IS_MINI_MODE = 'SET_IS_MINI_MODE'
export const SET_IS_MENU_OPEN = 'SET_IS_MENU_OPEN'
export const SET_IS_MOBILE_MENU_OPEN = 'SET_IS_MOBILE_MENU_OPEN'
export const SET_IS_MINI_SWITCH_VISIBILITY = 'SET_IS_MINI_SWITCH_VISIBILITY' 
